"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import { modal } from "../../modules/_modal";

window.addEventListener("load", () => {
  modal();
  projectSort();
});

function projectSort() {
  const items = document.querySelectorAll(".project-contetnt-item");
  const terms = [];
  const buttons = document.querySelectorAll(".project-contetnt-sort__item");

  for (const button of buttons) {
    button.addEventListener("click", function () {
      ScrollTrigger.refresh();
      // クリックしたボタンにクラス付与
      buttons.forEach((item) => {
        item.classList.remove("is-active");
      });
      button.classList.add("is-active");
      items.forEach((item) => {
        item.classList.add("is-active");
        window.setTimeout(function () {
          item.classList.remove("is-active");
          terms.shift(); // 配列の先頭を削除
        }, 1000);
      });
      // クリックした条件を絞り込み条件リストに追加/削除
      const term = button.getAttribute("data-term");
      const termPosition = terms.indexOf(term);
      if (termPosition !== -1) {
        terms.splice(termPosition, 1);
      } else {
        terms.push(term);
      }
      // console.log("terms: ", terms);
      // 絞り込み
      for (const item of items) {
        // 選択されてる条件ないなら全てのis-remove取って処理終了
        if (terms.length === 0) {
          window.setTimeout(function () {
            item.classList.replace("is-remove", "is-add");
          }, 300);
          continue;
        }
        // 空白削除して配列に
        const itemTagsArray = item
          .getAttribute("data-tag")
          .replace(/\s+/g, "")
          .split(",");
        const isMatched = terms.some(function (term) {
          return itemTagsArray.indexOf(term) !== -1;
        });
        if (isMatched && item.classList.contains("is-remove")) {
          // 現在の条件と一致しててis-removeクラスあるならis-removeクラス外す
          window.setTimeout(function () {
            item.classList.replace("is-remove", "is-add");
          }, 300);
        } else if (!isMatched && !item.classList.contains("is-remove")) {
          // 現在の条件と一致してなくてis-removeクラスもなければis-removeクラス付与
          window.setTimeout(function () {
            item.classList.add("is-remove");
          }, 300);
        }
      }
    });
  }
}
